// extracted by mini-css-extract-plugin
export var statItem = "_k5-1";
export var statsRow = "_k5-0";